import { Grid } from "@mui/material";
import classes from "./formActionSection.module.css";

const FormActionSection = ({
  observe,
  cancelHandler,
  restore,
  submitFormHandler,
  submitCustomTxt,
  updateFormHandler,
  updateCustomTxt,
  edit,
}) => {
  const renderValue = (
    <>
      {!edit ? (
        <>
          <Grid container item xs={12} className={classes.formSubmitContainer}>
            <button className={classes.cancelBtn} onClick={cancelHandler}>
              انصراف
            </button>
            {observe ? null : (
              <button className={classes.submitBtn} type="submit" onClick={submitFormHandler}>
                {restore ? "بازگرداندن" : submitCustomTxt ? submitCustomTxt : "ذخیره"}
              </button>
            )}
          </Grid>
        </>
      ) : (
        <Grid container item xs={12} className={classes.formSubmitContainer}>
          <button className={classes.cancelBtn} onClick={cancelHandler}>
            انصراف
          </button>
          <button className={classes.submitBtn} type="submit" onClick={updateFormHandler}>
            به روزرسانی
          </button>
        </Grid>
      )}
    </>
  );

  return renderValue;
};

export default FormActionSection;
